<template>
	<div>
		<div v-if="model">
		    <form class="modern" @submit.prevent="onSubmit()" >    
		        <div class="bottom">
		            <div class="col-12 col-md-8 mt-1">
		                <div class="mb-4">
		                    <p class="title-sm"><span v-if="model.id">EDITAR</span> <span v-if="!model.id">NOVA</span> CATEGORIA FINANCEIRA</p>
		                    <p class="legend-sm"></p>
		                </div>

		                <div class="form-group row">
		                    <label class="col-12 col-md-2 col-form-label text-right text-left-mobile">Tipo</label>
		                    <div class="col-12 col-md-10">
		                        <select class="form-control" @change="changeType($event.target.value)" name="type" v-model="model.type">
		                            <option value="r">Receita</option>
		                            <option value="e">Despesa</option>
		                        </select>
		                    </div>
		                </div>

		                <div class="form-group row" v-if="!model.has_child">
		                    <label class="col-12 col-md-2 col-form-label text-right text-left-mobile">Categoria Mãe</label>
		                    <div class="col-12 col-md-10">
		                        <select class="form-control" name="parent_id" v-model="model.parent_id">
		                            <option value="">- Nenhuma - </option>
		                            <option v-for="category of categories" :value="category.id">{{ category.name }}</option>
		                        </select>
		                    </div>
		                </div>

		                <div class="form-group row">
		                    <label class="col-md-2 col-12 col-form-label text-right text-left-mobile">Nome *</label>
		                    <div class="col-12 col-md-10">
		                        <input type="text" name="name" class="form-control" required="true" 
		                        v-model="model.name">
		                    </div>
		                </div>
<!-- 
		                <div class="form-group row">
		                    <label class="offset-md-2 form-check-label text-grey">
		                        <input #defaultCheckbox name="default" v-model="model.default" class="form-check-input" type="checkbox">
		                        Categoria Padrão
		                    </label>
		                </div> -->

		            </div>
		        </div>

		        <div class="py-3 pr-3 text-right" style="background-color: #f6f6f6;">
			        <div v-if="model.id && !areYouSure" class="remove-button-area" @click="remove(model)">
			          <i class="fa fa-trash-o"></i>
			          <a class="delete-area mr-auto">Excluir</a>
			        </div>
			        <div v-if="model.id && areYouSure" class="remove-button-area red" @click="removeAgain(model)">
			          <i class="fa fa-trash-o"></i>
			          <a class="delete-area mr-auto">Toque novamente</a>
			        </div>
		            <a class="btn btn-secondary pointer text-white" @click="cancel()">Cancelar</a>
		            <button class="btn btn-success pointer" :disabled="loading">Salvar</button>            
		        </div>
		    </form>
		</div>
	</div>
</template>

<script>
	import Category from '@/models/Category'
	import CategoryService from '@/services/CategoryService'

	export default {
		data() {
			return {
				categories: [],
				loading: false,
				model: null,
				areYouSure: false
			}
		},
		methods: {
			cancel() {
				this.model = null;
				this.$emit('onCancelled', true)
			},

			changeType(event) {
				if(event == 'r')
					this.load(event)
				else if(event == 'e')
					this.load(event)
			},

			load(type) {
				let params = '?parent=true&';

				if(type) {
					params += 'type=' + type
				}

				CategoryService.load(params)
					.then(res => {
						this.categories = res.data
					})
			},
			onSubmit() {
				this.loading = true;

				CategoryService.createOrUpdate(this.model)
					.then(res => {
						this.loading = false;
						this.cancel()
					})
			},
			open(model) {
				this.model = Object.assign({}, model)
				this.load(model.type)
			},
			remove(category) {
				this.areYouSure = true
				setTimeout(() => {
					this.areYouSure = false;
				}, 2000)
			},
			removeAgain(category) {
				CategoryService.remove(category.id).then(res => {
					this.cancel()
				}).catch(err =>{
					this.cancel()
				})
			}
		},
		mounted() {
			this.load('r')
		}
	}
</script>
<style>

	.remove-button-area {
		padding: 20px;
		padding-top: 10px;
		padding-bottom: 10px;
		margin-left: 20px;
		margin-top: 10px;
		cursor: pointer;
		float: left;
	}
	.remove-button-area > a {
		margin-left: 5px;
	}
	.remove-button-area:hover {
		background-color: #eee;
	}
	.remove-button-area:hover > i {
	}
	.remove-button-area.red{
		color: red;
	}
</style>